import axios from "axios";

const getAssignProgress = (uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/serialnumber/assign/${uuid}/progress`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAssignProgress;
